// Timeline renderer component for displaying visual timeline in AG Grid cells
import Box from '@mui/material/Box';
import { memo } from 'react';
import { createTimelineString, createTimelineTooltip, hasOpenActions } from '../utils/timelineUtils';

/**
 * Renders a timeline visualization in a table cell with tooltip
 */
const TimelineRenderer = memo(({ data }) => {
  if (!data) return null;

  const hasActions = hasOpenActions(data);
  
  const timelineString = createTimelineString({
    creationDate: data.initialLeadDate,
    lastUpdatedDate: data._ts ? new Date(data._ts * 1000) : data.lastActivity,
    hasOpenAction: hasActions,
    status: data.status
  });

  const tooltipText = createTimelineTooltip({
    creationDate: data.initialLeadDate,
    lastUpdatedDate: data._ts ? new Date(data._ts * 1000) : data.lastActivity,
    hasOpenAction: hasActions,
    status: data.status,
    followUpDate: data.followUp
  });

  return (
    <Box
      sx={{
        fontFamily: 'monospace',
        fontSize: '0.9rem',
        fontWeight: 'bold',
        letterSpacing: '1px',
        color: '#2c3e50',
        cursor: 'help',
        padding: '4px 8px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'flex-end',
        minWidth: 'fit-content',
        whiteSpace: 'nowrap',
        width: '100%',
        height: '100%'
      }}
      title={tooltipText}
    >
      {timelineString}
    </Box>
  );
});

TimelineRenderer.displayName = 'TimelineRenderer';

export default TimelineRenderer;